import React from "react";
import { useField } from "formik";
import { FormControl, RadioGroup, FormControlLabel, Radio, Box, Typography } from "@mui/material";

interface RadioOption {
  key: string;
  text: string;
  value: any;
  disabled?: boolean;
}

interface Props {
  name: string;
  options: RadioOption[];
  label?: string;
  required?: boolean;
  flexDirection?: any;
}

export default function CustomRadioInput(props: Props) {
  const [field, meta, helpers] = useField(props.name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    const selected = props.options.find(o => String(o.value) === String(raw));
    helpers.setValue(selected ? selected.value : raw);
    helpers.setTouched(true);
  };

  return (
    <Box sx={{ mb: 2 }}>
      {props.label && (
        <Typography variant="body2" sx={{ mb: 0.5 }}>
          {props.label}
          {props.required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
        </Typography>
      )}
      <FormControl error={meta.touched && !!meta.error} component="fieldset" sx={{ width: "100%" }}>
        <RadioGroup
          name={props.name}
          value={field.value !== undefined && field.value !== null ? String(field.value) : ""}
          onChange={handleChange}
          row={props.flexDirection === "row"}
        >
          {props.options.map((option) => (
            <FormControlLabel
              key={option.key}
              value={String(option.value)}
              control={<Radio />}
              label={option.text}
              disabled={option.disabled}
            />
          ))}
        </RadioGroup>
        {meta.touched && meta.error && (
          <Typography color="error" variant="caption">
            {meta.error}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
}
